const minimumPrice = (data) => {
    return false
}

export default minimumPrice;